import { gate } from 'hub-http/gates';
import { useHasGate } from './useHasGate';

const ALL_VIEWS_BULK_ACTIONS_GATE = gate('CRM:Datasets:AllViewsBulkActions');

export const useHasBulkActionsGate = () => {
  const { loading, data } = useHasGate(ALL_VIEWS_BULK_ACTIONS_GATE);
  return !loading && Boolean(data);
};
